import { lazy } from 'react';

export const UpdateTariffPageLazy = lazy(() => import('./UpdateTariffPage'));
